import React from "react";
import GameWindowHeader from "../../../../components/InGameUI/GameWindowHeader";
import GameWindowBg from "../../../../components/InGameUI/GameWindowBg";
import {CLIENT_NAMES} from "../../../../constants/Constants";
import {CLIENT_COLORS} from "../../../../components/InGameUI/GameStyleUI";

export default class StationPlaceCard extends React.Component{

    render() {
        let colors = CLIENT_COLORS[this.props.client]
        return <div style={{
            paddingRight: 5,
        }}>
            <GameWindowHeader width={80} height={25}
                              positionTop={6}
                              positionLeft={5}
                              colorStart={colors[0]}
                              colorEnd={colors[1]}
                              fontSize={12}
                              title={CLIENT_NAMES[this.props.client]
                              ?? "Прочее"} />
            <GameWindowBg width={80} height={30} value={<div style={{paddingTop: 5}}>{`${this.props.reserved}/${this.props.free}`}</div>}
            />
        </div>;
    }
}
